// TODO: delete when new customize UI enabled for everyone
import { action, extendObservable, reaction } from 'mobx';
import PropTypes from 'prop-types';
import AsyncActionStore from './AsyncActionStore';
import FlagStore from './FlagStore';
import InputStore from './InputStore';
import EditCustomPageContentStore from './EditCustomPageContentStore';

export default class RegistrationNoticeStore {
    static TYPE_REGISTRATION_NOTICE = 'REGISTRATION_NOTICE';
    static PropType = PropTypes.shape({
        enabledStore: FlagStore.PropType.isRequired,
        isModalOpen: FlagStore.PropType.isRequired,
        headline: PropTypes.string.isRequired,
        hasChanged: PropTypes.func.isRequired,
        headlineStore: InputStore.PropType.isRequired,
        editCustomPageContent: EditCustomPageContentStore.PropType.isRequired,
        exitConfirmationModal: FlagStore.PropType.isRequired,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class RegistrationNoticeStore */{
            loadStatus: new AsyncActionStore(),
            saveStatus: new AsyncActionStore(),
            headline: 'Please review',
            enabled: false,
            previewToggle: new FlagStore(false),
            previewToggleInEditMode: new FlagStore(true),
            isModalOpen: new FlagStore(false),
            enabledStore: new FlagStore(this.enabled),
            exitConfirmationModal: new FlagStore(false),
            headlineStore: new InputStore({ value: this.headline }),
            editCustomPageContent: new EditCustomPageContentStore({ validator: (str) => str && str.trim().length > 0 }),
            isValid: () => !this.enabledStore.value || this.editCustomPageContent.isValid(),
            hasChanged: () => !this.enabledStore.equals(this.enabled)
                || !this.headlineStore.equals(this.headline)
                || this.editCustomPageContent.hasChanged(),
        }, data);

        reaction(() => this.enabledStore.value, (newValue) => newValue && this.previewToggle.setValue(newValue));
    }

    setValue = action((data) => {
        this.enabled = data.enabled;
        this.enabledStore.setValue(data.enabled);
        const content = JSON.parse(data.content);
        this.headline = content.headline;
        this.headlineStore.setValue(content.headline);
        this.editCustomPageContent.setValue(content.message);
    });

    clean() {
        this.enabledStore.setValue(this.enabled);
        this.headlineStore.setValue(this.headline);
        this.editCustomPageContent.setValue(this.editCustomPageContent.message);
    }

    getValue() {
        return {
            type: RegistrationNoticeStore.TYPE_REGISTRATION_NOTICE,
            enabled: this.enabledStore.value,
            content: JSON.stringify(this.getContent()),
        };
    }

    getContent() {
        return {
            logo: '',
            logoName: '',
            headline: this.headlineStore.value,
            headlineIcon: false,
            background: false,
            message: this.editCustomPageContent.messageStore.value,
        };
    }

    closeModal = action(() => {
        this.isModalOpen.close();
        this.clean();
    });

    existEditMode = action(() => {
        if (this.hasChanged()) {
            this.exitConfirmationModal.setTrue();
        } else {
            this.closeModal();
        }
    });
}

